var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.dialogVisible
    ? _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "编辑商品",
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            width: "60%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "contents" },
            [
              _c("div", { staticClass: "infodata" }, [
                _c("div", [_vm._v("货号：" + _vm._s(_vm.formData.sku_code))]),
                _c("div", [
                  _vm._v("供应商：" + _vm._s(_vm.formData?.supplier?.title)),
                ]),
                _c("div", [_vm._v("开市价：" + _vm._s(_vm.formData?.price))]),
              ]),
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.formData,
                    rules: _vm.rules,
                    "label-width": "10%",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "业务员", prop: "buyer_id" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择业务员",
                            filterable: "",
                          },
                          on: { change: _vm.onBuyerChange },
                          model: {
                            value: _vm.formData.buyer_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "buyer_id", $$v)
                            },
                            expression: "formData.buyer_id",
                          },
                        },
                        _vm._l(_vm.buyer_list, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.fullname, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否共享品", prop: "is_share" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: _vm.cid_type != 1 },
                          model: {
                            value: _vm.formData.is_share,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "is_share", $$v)
                            },
                            expression: "formData.is_share",
                          },
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 1, disabled: !_vm.buyerCanShare },
                            },
                            [_vm._v("是")]
                          ),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("否"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.logistic_business_id == 549
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "第三方服务费",
                            prop: "service_charges",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入第三方服务费" },
                            model: {
                              value: _vm.formData.service_charges,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "service_charges", $$v)
                              },
                              expression: "formData.service_charges",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: "推广奖励", prop: "promotion_charges" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入推广奖励" },
                        model: {
                          value: _vm.formData.promotion_charges,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "promotion_charges", $$v)
                          },
                          expression: "formData.promotion_charges",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.type == 1 &&
                  _vm.formData.creator_type != 1 &&
                  _vm.formData.creator_type != 2
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "标签", prop: "promotion_tag_id" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择标签",
                                multiple: "",
                              },
                              model: {
                                value: _vm.promotion_tag_id,
                                callback: function ($$v) {
                                  _vm.promotion_tag_id = $$v
                                },
                                expression: "promotion_tag_id",
                              },
                            },
                            _vm._l(
                              _vm.promotion_tag_list,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.name,
                                    value: item.id + "",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.promotion_tag_id_change(
                                        $event,
                                        item
                                      )
                                    },
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("el-alert", {
                attrs: {
                  title: "请确保业务知晓更改事项，后台数据更改均会记录日志",
                  type: "warning",
                  closable: false,
                  "show-icon": "",
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.onHandleClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loadingSubmit },
                  on: { click: _vm.onHandleSubmit },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }